import { Injectable } from '@angular/core';
import { ReplaySubject } from 'rxjs';
import { BreadcrumbData } from '@mds/ui';
import { AnalyzeBreadcrumbData } from '@mds/common';

export type filterDataType = BreadcrumbData<AnalyzeBreadcrumbData> | boolean | void;

export enum FilterAndBreadcrumbEventName {
  SHOW_ALL_DATA = 'SHOW_ALL_DATA',
  BREADCRUMB = 'BREADCRUMB',
  BACK_TO_DEFAULT = 'BACK_TO_DEFAULT',
  GROUP_NODES = 'GROUP_NODES',
  TARIFF_DATA = 'TARIFF_DATA',
  TARIFF_SELECTION = 'TARIFF_SELECTION'
}

export interface FilterData {
  eventType: FilterAndBreadcrumbEventName;
  value: filterDataType;
}

@Injectable({ providedIn: 'root' })
export class FilterAndBreadcrumbEventsService {
  private filterDataChangedSubject = new ReplaySubject<FilterData>(1);

  // Expose as read-only Observable to prevent direct modifications
  filterDataChanged$ = this.filterDataChangedSubject.asObservable();

  constructor() {}

  /** Emit new filter data */
  emitFilterEvent(filterData: FilterData): void {
    this.filterDataChangedSubject.next(filterData);
  }
}
